/* Customer Script Overrides included in <head> */

// window.tooltipOpts = {placement: 'auto', trigger: 'hover', container: 'body', html: true};
// window.spinOpts = { lines: 12, length: 7, width: 5, radius: 10, scale: 1, corners: 1, color: '#444', opacity: 0.25, rotate: 0, direction: 1, speed: 1, trail: 60, fps: 20, zIndex: 2e9, className: 'spinner', top: '50%', left: '50%', shadow: false, hwaccel: false, position: 'absolute' }

$(function() {

    // Set initial panel state - make sure all panels that are toggle-able are open
    openPanel($('.panel').has('.panel-toggle'));

    // other examples:
    //
    // Open all panels on setup page (set.asp) using special class panel-setup
    // openPanel($('.panel.panel-setup'));
    //
    // Open the first panel (report type) on summary and detail reports lists using shared special class panel-reports
    // openPanel($('.panel.panel-reports:first'));
});

function closePanel($panels) {
    $('.panel-toggle', $panels).addClass('collapsed');
    $('.panel-collapse', $panels).removeClass('in');
}

function openPanel($panels) {
    $('.panel-toggle', $panels).removeClass('collapsed');
    $('.panel-collapse', $panels).addClass('in');
}

// Use a different paging type
/*
$.extend( true, $.fn.dataTable.defaults, {
    "pagingType": "input"
});
*/
// Sample on how to override the default layout of a datatable.  See https://datatables.net/reference/option/dom for more info
/*
$.extend( true, $.fn.dataTable.defaults, {
    "dom":  "<'row table-above-row'<'col-sm-12 table-actions'<'table-pagination right'p>>>" +
            "<'row'<'col-sm-12'tr>>" +
            "<'row'<'col-sm-5'i><'col-sm-7'>>",
});
*/
// Sample on how to move contents of .action-bank inside the pre-table div with, say, pagination and/or page length controls.
// This should be used in coordination with overriding the default layout of a datatable, even if the override is the exact
// same as the default (for clarity).
/*
$(document).on('init.dt', function (settings, json) {
    var $dt = $('div.dataTables_wrapper');
    var $ab = $('div.action-bank');
    if ($dt.length==1 && $ab.length==1 && !$dt.has('.action-bank').length)
    {
        $('div.table-actions', $dt).append($ab);
    }
});
*/